<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <DemandTabLinks />
                    <DemandUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @update="fetch"
                        @schedule-updated="fetch"
                        @success="$router.push(`/demands`)"
                        @deleted="$router.push(`/demands`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import DemandTabLinks from '@/components/demands/DemandTabLinks';
    import DemandUpsertForm from '@/components/demands/DemandUpsertForm';

    export default {
        name: 'DemandEdit',

        components: {
            DemandTabLinks,
            DemandUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/demands/${id}`)).data;
            },
        },
    };
</script>
